import { VIEW_CLAIMS } from '@/common/permissionConstants';
import { useFeatureFlags } from '@/composables/useFeatureFlags';

const featureFlagGuard = () => {
    const { isEnabled } = useFeatureFlags();
    if (!isEnabled('availity-claims')) return { name: 'home' };
};

export default [
    {
        path: 'availity/remittances',
        name: 'availity-remittances',
        meta: { label: 'Remittance review', hasPermission: VIEW_CLAIMS },
        component: () => import('@/views/AvailityEraReviewPage.vue'),
        beforeEnter: featureFlagGuard,
    },
    {
        path: 'availity/files',
        name: 'availity-files',
        meta: { label: 'Availity file activity', hasPermission: VIEW_CLAIMS },
        component: () => import('@/views/AvailityFilesPage.vue'),
        beforeEnter: featureFlagGuard,
    },
];
